// Typed static client for the /IngestionQueue/* get + complete endpoints
// (SD-2337 / PR 3a). All-static, returns typed data (never a raw AxiosResponse),
// rethrows errors. Follows the PositiveIdService precedent.
//
// Scope: GET (fetch a queue item) and POST (mark complete) only. The heartbeat
// LockHandler sites (/IngestionQueue/{id}/Lock at mount and /{id}/lock in-save)
// deliberately stay on the container as addLockWithURL calls — a one-shot service
// POST would drop the 60s refresh, generation guard, locks[] registry, and
// auto-release-on-conflict that those sites carry.

import axios from 'axios'
import { QueueItem } from '@/models/QueueItem'

export class IngestionQueueService {
    /**
     * Fetch a queue item by id. Rethrows — the call site keeps its 418
     * lock-conflict handling.
     */
    static async getById(id: string | number): Promise<QueueItem> {
        const response = await axios.get<QueueItem>(`/IngestionQueue/${id}`)
        return response.data
    }

    /**
     * Mark queue items complete. The server takes (and returns) an array; a
     * "Not A Script" completion is an item carrying only its id.
     */
    static async complete(items: QueueItem[]): Promise<QueueItem[]> {
        const response = await axios.post<QueueItem[]>('/IngestionQueue/', items)
        return response.data
    }
}

export default IngestionQueueService
